import styled from 'styled-components';
import { system } from 'styled-system';
import { COMMON, get, TYPOGRAPHY } from './constants';
import sx from './sx';
var hoverColor = system({
  hoverColor: {
    property: 'color',
    scale: 'colors'
  }
});
var Link = styled.a.withConfig({
  displayName: "Link",
  componentId: "sc-1brdqhf-0"
})(["color:", ";text-decoration:", ";&:hover{text-decoration:", ";", ";}&:is(button){display:inline-block;padding:0;font-size:inherit;white-space:nowrap;cursor:pointer;user-select:none;background-color:transparent;border:0;appearance:none;}", ";", ";", ";"], function (props) {
  return props.muted ? get('colors.text.secondary')(props) : get('colors.text.link')(props);
}, function (props) {
  return props.underline ? 'underline' : 'none';
}, function (props) {
  return props.muted ? 'none' : 'underline';
}, function (props) {
  return props.hoverColor ? hoverColor : props.muted ? "color: ".concat(get('colors.text.link')(props)) : '';
}, TYPOGRAPHY, COMMON, sx);
export default Link;